// This file is for constants to be shared between core components

// these are the timing guilelines for hover interactions to be used with Dropdown and Tooltip components
export const mouseEnterDelay = 0.4
export const mouseLeaveDelay = 0.5

export const FUTURE_DATE_FORMAT = 'ddd, MMM D'
